import Alert from '@/components/Alert/Alert'
import { UniversalWebViewRef } from '@/components/universalWebView/types'
import usePreventLeaveWeb from '@/lib/hooks/usePreventLeaveWeb'
import FormBuilderWebview from '@/modules/builder/FormBuilderWebview'
import { closePublishSheet, openPublishSheet } from '@/redux/slices/publishSheetSlice'
import { useAppDispatch } from '@/redux/store'
import { usePreventRemove } from '@react-navigation/native'
import { useLocalSearchParams, useNavigation } from 'expo-router'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { KeyboardAvoidingView, Platform } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import FormStackScreen from './FormStackScreen'

export default function FormBuilderPage() {
  const insets = useSafeAreaInsets()
  const { formToken } = useLocalSearchParams<{ formToken: string }>()
  const dispatch = useAppDispatch()
  const navigation = useNavigation()
  const [isDirty, setIsDirty] = useState(false)
  const webviewRef = useRef<UniversalWebViewRef>(null)

  usePreventRemove(isDirty, ({ data }) => {
    Alert.alert('编辑内容未保存', '当前编辑内容尚未保存，是否在离开前保存？', [
      { text: '取消', style: 'cancel' },
      {
        text: '不保存',
        style: 'destructive',
        onPress: () => navigation.dispatch(data.action),
      },
      {
        text: '保存',
        isPreferred: true,
        onPress: () => handleSave(),
      },
    ])
  })

  const handleSave = useCallback(() => {
    webviewRef.current?.postMessage(JSON.stringify({ event: 'SAVE_FORM' }))
  }, [])

  const preventLeaveOptions = useMemo(() => ({ onSave: handleSave }), [handleSave])

  usePreventLeaveWeb(isDirty, '编辑内容未保存', preventLeaveOptions)

  useEffect(() => {
    return () => {
      dispatch(closePublishSheet())
    }
  }, [dispatch])

  const handlePublishSuccess = useCallback(() => {
    dispatch(openPublishSheet({ formToken }))
  }, [dispatch, formToken])

  return (
    <KeyboardAvoidingView
      className="flex-1"
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={Platform.OS === 'android' ? { paddingBottom: insets.bottom } : undefined}
    >
      <FormStackScreen
        formToken={formToken}
        titlePrefix="编辑"
        defaultBackHref={`/forms/${formToken}`}
        headerTransparent={false}
      />
      <FormBuilderWebview
        ref={webviewRef}
        formToken={formToken}
        onPublishSuccess={handlePublishSuccess}
        onDirtyChange={setIsDirty}
      />
    </KeyboardAvoidingView>
  )
}
